// extracted by mini-css-extract-plugin
export var container = "_2x-0";
export var disabled = "_2x-3";
export var enabled = "_2x-2";
export var statusLight = "_2x-1";